import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-340d8b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Horcrux ", -1))
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Horcrux is generated from ")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" This service use Ethereum without any thirdparties. You only need to choose a strong secret and publish the encrypted Vault. Once it's done, we also recommand you to ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "print this page as a rescue tip", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" (Ctrl+p). ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, [
  /*#__PURE__*/_createTextVNode(" This is an alpha version running on testnet Ropsten. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" To test the service you can get free ETH there → "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_tab",
    href: "https://faucet.egorfine.com/"
  }, "faucet"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_12 = { class: "media-display" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Use an email of your choise to generate the first part of the secret", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = {
  class: "title",
  ref: "title",
  type: "text",
  placeholder: "Your printed title"
}
const _hoisted_19 = { class: "secret media-display" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Vault secret 🔑", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "code" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Psst;"),
  /*#__PURE__*/_createTextVNode(" Print this document as a rescue tip")
], -1))
const _hoisted_22 = { class: "hideemail" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = { class: "code hide-print" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Contract address : ")
const _hoisted_28 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_password = _resolveComponent("password")!

  return (!!_ctx.value.share)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h3", null, [
          _createTextVNode(_toDisplayString(_ctx.date) + " / ", 1),
          _createElementVNode("span", _hoisted_3, "v" + _toDisplayString(_ctx.value?.version), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("a", { href: _ctx.location }, _toDisplayString(_ctx.location), 9, _hoisted_6),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("fieldset", null, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              placeholder: "email@g.com",
              id: "email",
              autocomplete: "off",
              autocorrect: "off",
              autocapitalize: "off",
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, _ctx.username]
            ]),
            _createVNode(_component_password, {
              label: "Complete your secret with a strong password",
              onValue: _cache[1] || (_cache[1] = (value)=> _ctx.password=value),
              onScore: _ctx.onScore
            }, null, 8, ["onScore"]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmation) = $event)),
              placeholder: "Confirm the password",
              autocomplete: "off",
              autocorrect: "off",
              autocapitalize: "off",
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, _ctx.confirmation]
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onGenerate && _ctx.onGenerate(...args))),
              class: "button-primary",
              disabled: !_ctx.isPasswordOk
            }, _toDisplayString(_ctx.computing?'Computing...':'Create Vault'), 9, _hoisted_14),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPublish && _ctx.onPublish(...args))),
              class: "button-primary",
              disabled: (_ctx.seed == '')||_ctx.receipt
            }, _toDisplayString(_ctx.publishing?'Publishing...':'Publish/ETH'), 9, _hoisted_15),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPublishDrive && _ctx.onPublishDrive(...args))),
              class: "button-primary",
              disabled: (_ctx.seed == '')||_ctx.receipt
            }, _toDisplayString(_ctx.publishing?'Publishing...':'Publish/DRIVE'), 9, _hoisted_16)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["published", {hide:(!_ctx.tx)}])
        }, " Waiting transaction ... " + _toDisplayString(_ctx.tx?.hash), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["published", {hide:(!_ctx.receipt)}])
        }, [
          _createTextVNode(" Transaction confirmed in block " + _toDisplayString(_ctx.receipt?.blockNumber) + " ", 1),
          _hoisted_17,
          _createTextVNode(" Gas used: " + _toDisplayString(_ctx.receipt?.gasUsed.toString()), 1)
        ], 2),
        _createElementVNode("input", _hoisted_18, null, 512),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.value?.share), 1),
        _hoisted_20,
        _hoisted_21,
        _createElementVNode("div", {
          class: _normalizeClass(["secret", {hide:_ctx.seed==''}])
        }, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.hideUsermail), 1),
          _hoisted_23,
          _createTextVNode(" " + _toDisplayString(_ctx.seed.slice(0,8)) + " **** " + _toDisplayString(_ctx.seed.slice(-8)), 1),
          _hoisted_24,
          _createTextVNode(" " + _toDisplayString(_ctx.mixed), 1)
        ], 2),
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("a", {
            target: "_tab",
            href: 'https://ropsten.etherscan.io/address/'+_ctx.address
          }, _toDisplayString(_ctx.address), 9, _hoisted_28)
        ])
      ]))
    : _createCommentVNode("", true)
}